import { render } from "./ApprovedClassificationEntries.vue?vue&type=template&id=2b4461d4"
import script from "./ApprovedClassificationEntries.vue?vue&type=script&lang=js"
export * from "./ApprovedClassificationEntries.vue?vue&type=script&lang=js"

import "./ApprovedClassificationEntries.vue?vue&type=style&index=0&id=2b4461d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__